export const linkIncludesHttp = (link: string) => {
  return link.match(/^http(s)?:\/\//);
};
